module.exports = __webpack_public_path__ + "static/media/camera-scan.fe45f140.svg";